//Version 0.1.2 TULOSSA: Dokumenttien tallennus laitekohtaisesti.
// Version 0.1.1, 30.1.25. Lisätty uudet Kirjalansalmen laitteet väylän käyttöön.
// Version 0.1.1Beta, 22.1.25. Lisätty 4 uutta laitetta Kirjalansalmi. Betassa vasta omaan käyttöön.
// Version 0.1.0, 11.9.24. Lisätty 4 uutta laitetta Metsäfibrelle.
//import logo from './3-light-tight.svg';
import logo from './1-dark-tight.svg';
import './App.css';
import React, { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';

import axios from 'axios';

import Button from 'react-bootstrap/Button';
import ReactSwitch from 'react-switch';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//import ImageGallery from 'react-image-gallery';
//import "./image-gallery.css"; 

//import Tooltip from 'react-bootstrap/Tooltip';
import floppy from './floppy.svg';
import clock from './clock.svg';
import gear from './gear.svg';
import database from './database.svg';
import brilliance from './brilliance.svg';
import map from './map.svg';
import image from './image.svg';
import logout from './box-arrow-right.svg';

//import * as Icons from 'react-bootstrap-icons';
// Ikoneita: https://icons.getbootstrap.com/

// Recharts komponentti
//import Chart from './Chart';
import moment from 'moment';

import loginService from './services/login';

// Google maps
import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
  InfoWindow
} from "@vis.gl/react-google-maps";


const grafana_url = 'https://opus.iottech.fi/grafana';
//const grafana_url = 'http://51.15.114.61:3000';
const iottech_url = 'https://opus.iottech.fi'; // TÄMÄ ON OIKEA!
//const iottech_url = 'http://51.15.114.61:7095';
//const iottech_url = 'http://172.16.0.103:7095'; // Kotitesti
//const iottech_url = 'http://127.0.0.1:7095'; // Tämä kun käytetään ssh-tunnelin kautta kotiraspille
// HUOM!!! Muista muuttaa myös login.js:ssä oleva osoite

// https://www.brainstormcreative.co.uk/react-js/react-bootstrap-icons/

// https://react-bootstrap.netlify.app/docs/components/modal/

// Opettele tästä https://contactmentor.com/create-modal-react-js-overlay/


// TODO: Nämä kaksi haettavaksi backendistä
// Käyttäjät
const users = new Object();
users['all'] = "All";
users['pekka'] = "Pekka Toivola";
users['jani'] = "Jani";
users['helil'] = "Heli";
users['vayla'] = "Väylä";
users['metsafibre'] = "Metsä Fibre";
users['finavia'] = "Finavia";
users['htj'] = "htj";
users['ramboll'] = "Ramboll";
users['pasila'] = "Pasila";
users['mikael.vahtera@afry.com'] = "Mikael Vahtera";
users['janne.kauppi@op.fi'] = "Janne Kauppi";
users['taina.kuismin@htj.fi'] = "Taina Kuismi";
users['tero.kuikka@htj.fi'] = "Tero Kuikka";
users['micael.westerholm@haahtela.fi'] = "Micael Westerholm";

// Sitet
const sites = new Object();
sites['all'] = "All";
sites['kirjalansalmi'] = "Kirjalansalmi";
sites['metsafibre_joutseno'] = "Metsä Fibre Joutseno";
sites['rauma'] = "Jäähalli Rauma";
sites['finavia_airport'] = "Finavia airport";
sites['other'] = "Muut";
sites['pasila'] = "Pasila";
sites['keskio'] = "Keskiö";







// Otsikot laitteille
//const deviceTitles = new Map();
const deviceTitles = new Object();
/*
deviceTitles.set('7786373', '7786373 - Kaarina itä TEE');
deviceTitles.set('7786374', '7786374 - Kaarina länsi');
deviceTitles.set('7786375', '7786375 - Parainen itä');
deviceTitles.set('7786376', '7786376 - Parainen länsi');
*/

deviceTitles['7785075'] = '7785075';
deviceTitles['7786393'] = '7786393';
deviceTitles['7786394'] = '7786394';
deviceTitles['7786395'] = '7786395';
deviceTitles['7786841'] = '7786841';
deviceTitles['7788612'] = '7788612';
// Nämä tuli takaisin MetsäFibreltä koska niihin ei saatu yhteyttä. Testissä Mikkelissä.
deviceTitles['7786377'] = '7786377*'; //POIS -> EI TOIMINUT. Korvattu toisella
deviceTitles['7786379'] = '7786379*'; //POIS -> EI TOIMINUT. Korvatttu 

// Väylä
deviceTitles['7786373'] = '7786373 - Kaarina itä';
deviceTitles['7786374'] = '7786374 - Kaarina länsi';
deviceTitles['7786375'] = '7786375 - Parainen itä';
deviceTitles['7786376'] = '7786376 - Parainen länsi';
// Kirjalansalmi uudet
deviceTitles['7787609'] = '7787609 - 1 Pääaukko';
deviceTitles['7787610'] = '7787610 - 2 Pääaukko';
deviceTitles['7787611'] = '7787611 - 3 Paraisten tulosilta';
deviceTitles['7787612'] = '7787612 - 4 Paraisten tulosilta';


// Metsäfibre - Joutseno
deviceTitles['7786370'] = '1 - 7786370';
deviceTitles['7786380'] = '2 - 7786380';
deviceTitles['7786378'] = '3 - 7786378';
deviceTitles['7786398'] = '4 - 7786398';
deviceTitles['7786369'] = '5 - 7786369';
deviceTitles['7786397'] = '6 - 7786397';
deviceTitles['7786395'] = '7 - 7786395';
deviceTitles['7786393'] = '8 - 7786393';

// Jäähalli Rauma
deviceTitles['7786381'] = '1 - 7786381';
deviceTitles['7786382'] = '2 - 7786382';
deviceTitles['7786383'] = '3 - 7786383';
deviceTitles['7786384'] = '4 - 7786384';
deviceTitles['7786385'] = '5 - 7786385';
deviceTitles['7786386'] = '6 - 7786386';
deviceTitles['7786387'] = '7 - 7786387';
deviceTitles['7786388'] = '8 - 7786388';
deviceTitles['7786389'] = '9 - 7786389';
deviceTitles['7786390'] = '10 - 7786390';
deviceTitles['7786391'] = '11 - 7786391';

// Finavia
deviceTitles['7788611'] = '1 - 7788611';
deviceTitles['7788601'] = '2 - 7788601';
deviceTitles['7788602'] = '3 - 7788602';
deviceTitles['7788603'] = '4 - 7788603';
deviceTitles['7788610'] = '5 - 7788610';
deviceTitles['7787607'] = '6 - 7787607';
deviceTitles['7787608'] = '7 - 7787608';
deviceTitles['7788592'] = '8 - 7788592';
deviceTitles['7788593'] = '9 - 7788593';
deviceTitles['7788594'] = '10 - 7788594';
deviceTitles['7788595'] = '11 - 7788595';
deviceTitles['7788596'] = '12 - 7788596';
deviceTitles['7788597'] = '13 - 7788597';
deviceTitles['7788598'] = '14 - 7788598';
deviceTitles['7788599'] = '15 - 7788599';
deviceTitles['7788600'] = '16 - 7788600';

// Pasilan keskitorni
deviceTitles['7788604'] = '1 - 7788604';
//deviceTitles['7788605'] = '2 - 7788605';
deviceTitles['7788601'] = '2 - 7788601';
deviceTitles['7788606'] = '3 - 7788606';
deviceTitles['7788607'] = '4 - 7788607';
deviceTitles['7788609'] = '5 - 7788609';
deviceTitles['7788617'] = '6 - 7788617';

// Taloyhtiö Keskiö
deviceTitles['7788602'] = '1 - 7788602';
deviceTitles['7788603'] = '2 - 7788603';
deviceTitles['7788610'] = '3 - 7788610';
deviceTitles['7788592'] = '4 - 7788592';
deviceTitles['7788593'] = '5 - 7788593';
deviceTitles['7788594'] = '6 - 7788594';
deviceTitles['7788595'] = '7 - 7788595';
deviceTitles['7788596'] = '8 - 7788596';
deviceTitles['7788597'] = '9 - 7788597';
deviceTitles['7788598'] = '10 - 7788598';
deviceTitles['7788599'] = '11 - 7788599';
deviceTitles['7788600'] = '12 - 7788600';


// Testilaitteet
deviceTitles['7788587'] = '7788587';
deviceTitles['7788588'] = '7788588';
deviceTitles['7788589'] = '7788589';
deviceTitles['7788590'] = '7788590';

// Testissä virtuaalilaitenumerot
deviceTitles['7788611-2'] = '1 - 7788611-2';



const DeviceSelect = ({title, onApply}) => {
  return (
    <Dropdown> 
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7785075')}>7785075</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786393')}>7786393</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786394')}>7786394</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786395')}>7786395</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786841')}>7786841</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788612')}>7788612</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786377')}>7786377</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786379')}>7786379</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7786373')}>7786373</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786374')}>7786374</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786375')}>7786375</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786376')}>7786376</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7787609')}>7787609</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787610')}>7787610</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787611')}>7787611</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787612')}>7787612</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7786370')}>7786370</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786380')}>7786380</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786378')}>7786378</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786398')}>7786398</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786369')}>7786369</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786397')}>7786397</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786395')}>7786395</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786393')}>7786393</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7786381')}>7786381</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786382')}>7786382</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786383')}>7786383</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786384')}>7786384</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786385')}>7786385</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786386')}>7786386</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786387')}>7786387</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786388')}>7786388</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786389')}>7786389</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786390')}>7786390</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786391')}>7786391</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7788611')}>7788611</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788601')}>7788601</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788602')}>7788602</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788603')}>7788603</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788610')}>7788610</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787607')}>7787607</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787608')}>7787608</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788592')}>7788592</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788593')}>7788593</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788594')}>7788594</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788595')}>7788595</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788596')}>7788596</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788597')}>7788597</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788598')}>7788598</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788599')}>7788599</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788600')}>7788600</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7788604')}>7788604</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788601')}>7788601</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788606')}>7788606</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788607')}>7788607</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788609')}>7788609</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788617')}>7788617</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7788602')}>7788602</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788603')}>7788603</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788610')}>7788610</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788592')}>7788592</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788593')}>7788593</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788594')}>7788594</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788595')}>7788595</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788596')}>7788596</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788597')}>7788597</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788598')}>7788598</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788599')}>7788599</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788600')}>7788600</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7788587')}>7788587</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788588')}>7788588</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788589')}>7788589</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788590')}>7788590</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7788611-2')}>7788611-2</Dropdown.Item>

    </Dropdown.Menu>
    </Dropdown>

  )
}

const DeviceSelect_vayla = ({title, onApply}) => {
  // TODO: Tänne uudet kirjalansalmen laitteet. Asennettu 21.1.25. 7787609 - 7787612

  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7786373')}>{deviceTitles['7786373']}</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786374')}>7786374 - Kaarina länsi</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786375')}>7786375 - Parainen itä</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786376')}>7786376 - Parainen länsi</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7787609')}>7787609 - 1 Pääaukko</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787610')}>7787610 - 2 Pääaukko</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787611')}>7787611 - 3 Paraisten tulosilta</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787612')}>7787612 - 4 Paraisten tulosilta</Dropdown.Item>
    </Dropdown.Menu>
    </Dropdown>

  )
}

const DeviceSelect_metsafibre = ({title, onApply}) => {
  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7786370')}>{deviceTitles['7786370']}</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786380')}>2 - 7786380</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786378')}>3 - 7786378</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786398')}>4 - 7786398</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786369')}>5 - 7786369</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786397')}>6 - 7786397</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786395')}>7 - 7786395</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786393')}>8 - 7786393</Dropdown.Item>
    </Dropdown.Menu>
    </Dropdown>

  )
}


const DeviceSelect_rauma = ({title, onApply}) => {
  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7786381')}>{deviceTitles['7786381']}</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786382')}>2 - 7786382</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786383')}>3 - 7786383</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786384')}>4 - 7786384</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786385')}>5 - 7786385</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786386')}>6 - 7786386</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786387')}>7 - 7786387</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786388')}>8 - 7786388</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786389')}>9 - 7786389</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786390')}>10 - 7786390</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7786391')}>11 - 7786391</Dropdown.Item>
    </Dropdown.Menu>
    </Dropdown>

  )
}

const DeviceSelect_finavia = ({title, onApply}) => {
  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7788611')}>{deviceTitles['7788611']}</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788601')}>2 - 7788601</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788602')}>3 - 7788602</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788603')}>4 - 7788603</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788610')}>5 - 7788610</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787607')}>6 - 7787607</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7787608')}>7 - 7787608</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788592')}>8 - 7788592</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788593')}>9 - 7788593</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788594')}>10 - 7788594</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788595')}>11 - 7788595</Dropdown.Item>

      <Dropdown.Item onClick={() => onApply('7788596')}>12 - 7788596</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788597')}>13 - 7788597</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788598')}>14 - 7788598</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788599')}>15 - 7788599</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788600')}>16 - 7788600</Dropdown.Item>

    </Dropdown.Menu>
    </Dropdown>

  )
}

const DeviceSelect_pasila_keskitorni = ({title, onApply}) => {
  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7788604')}>{deviceTitles['7788604']}</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788601')}>2 - 7788601</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788606')}>3 - 7788606</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788607')}>4 - 7788607</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788609')}>5 - 7788609</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788617')}>6 - 7788617</Dropdown.Item>
    </Dropdown.Menu>
    </Dropdown>

  )
}

const DeviceSelect_keskio = ({title, onApply}) => {
  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7788602')}>{deviceTitles['7788602']}</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788603')}>2 - 7788603</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788610')}>3 - 7788610</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788592')}>4 - 7788592</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788593')}>5 - 7788593</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788594')}>6 - 7788594</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788595')}>7 - 7788595</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788596')}>8 - 7788596</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788597')}>9 - 7788597</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788598')}>10 - 7788598</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788599')}>11 - 7788599</Dropdown.Item>
      <Dropdown.Item onClick={() => onApply('7788600')}>12 - 7788600</Dropdown.Item>
    </Dropdown.Menu>
    </Dropdown>

  )
}

const DeviceSelect_testi = ({title, onApply}) => {
  return (
    <Dropdown>
    <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
      {title}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => onApply('7788611-2')}>{deviceTitles['7788611-2']}</Dropdown.Item>
    </Dropdown.Menu>
    </Dropdown>

  )
}


//function Range(props) {
const RangeModalForm = ({show, onApply, onCancel, theme}) => {
  console.log('range theme', theme)
  //let calculatedStartDate = new Date();
  //calculatedStartDate.setHours(calculatedStartDate.getHours() - 24);
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [selectedRange, setSelectedRange] = useState('24h');
  const [selectedRefresh, setSelectedRefresh] = useState('Off');
  // TODO: Tätä listaa voisi käyttääkin
  let rangelist = ['15m', '60m', '2h', '3h', '6h', '24h', '7d', '30d', '60d'];
  let refreshlist = ['Off', '5s', '10s', '30s', '1m', '5m', '15m', '30m', '1h'];


  const applyRange = () => {
    /* Poistettu käytöstä koska lisätty valintaan tunnit ja minuutit
    console.log('applyRange ennen', selectedStartDate, selectedEndDate)
    selectedStartDate.setHours(0);
    selectedStartDate.setMinutes(0);
    selectedStartDate.setSeconds(0);

    selectedEndDate.setHours(23);
    selectedEndDate.setMinutes(59);
    selectedEndDate.setSeconds(59);
*/

    console.log('applyRange', selectedStartDate, selectedEndDate)

    const ret = {
      selectedStartDate: selectedStartDate,
      selectedEndDate: selectedEndDate,
      selectedRange: selectedRange,
      selectedRefresh: selectedRefresh
    }

    onApply(ret);
  } 

// Modalista pois: size="sm"
  return (
    <div>
    <Modal
      
      show={show}
      >
      <Modal.Header closeButton>
        <Modal.Title>
          Select range
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Container fluid>
          <Row> 
            <Col>
              <DatePicker className="col-11" 
                selected={selectedStartDate} 
                onChange={(date) => 
                  { setSelectedStartDate(date); setSelectedRange(null); setSelectedRefresh('Off'); } } 
                dateFormat="dd.MM.yyyy HH:mm"
                showTimeSelect 
                timeFormat="HH:mm" 
              />
            </Col> 
            <Col>
              <DatePicker className="col-11"
              selected={selectedEndDate} 
              onChange={(date) => { setSelectedEndDate(date); setSelectedRange(null); setSelectedRefresh('Off'); } } 
              dateFormat="dd.MM.yyyy HH:mm"
              showTimeSelect 
              timeFormat="HH:mm"
            />
            </Col>
          </Row>

          <Row>
            <Col>
              Range:{selectedRange} 
            </Col>
            <Col>
              <Dropdown>
                <Dropdown.Toggle className="col-10" variant="warning" id="dropdown-basic">
                  Range
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setSelectedRange('15m')}>Last 15 min</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('60m')}>Last 60 min</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('2h')}>Last 2 h</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('3h')}>Last 3 h</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('6h')}>Last 6 h</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('24h')}>Last 24 h</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('7d')}>Last 7 days</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('30d')}>Last 30 days</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRange('60d')}>Last 60 days</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>

        </Row>
        <Row>
            <Col>
            Refresh:{selectedRefresh}
            </Col>
            <Col>

              <Dropdown>
                <Dropdown.Toggle className="col-10 mx-auto" variant="warning" id="dropdown-basic">
                  Refresh
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setSelectedRefresh('Off')}>Off</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('5s')}>5s</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('10s')}>10s</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('30s')}>30s</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('1m')}>1m</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('5m')}>5m</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('15m')}>15m</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('30m')}>30m</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectedRefresh('1h')}>1h</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              
            </Col>
          </Row>
          
      </Container>

    </Modal.Body>

    <Modal.Footer>
      <Button className="btn btn-primary" onClick={onCancel}  style={{backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }}>Cancel</Button>
      <Button className="btn btn-primary" onClick={applyRange} style={{backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }}>Apply</Button>
      {/*<Button className="btn btn-primary" onClick={applyRange} >Apply</Button>*/}
    </Modal.Footer>

    </Modal>
    </div>
  )
}

const SaveFileModalForm = ({show, onApply, onCancel, theme}) => {

  const [selectedFile, setSelectedFile] = useState("test.csv");
  const [selectedFolder, setSelectedFolder] = useState(null);

  // Comboboxi
  const [item, setItem] = useState({ saveFileType: "accelerometer" })
  const {saveFileType} = item;

  const handleSaveFileTypeChange = e => {
    e.persist();
    setItem(prevState => ({
      ...prevState,
      saveFileType: e.target.value
    }))
  }
  // ...Comboboxi

  const apply = () => {
    const ret = {
      filename: selectedFile,
      filetype: saveFileType
    }
    console.log('file apply', ret)
    onApply(ret);
  } 
/*
  const handleClose = () => {
    onclose();
    setSelectedFile('');
    setSelectedFolder(null);
  }

  const handleSave = () => {
    onSave(selectedFile, selectedFolder);
    handleClose();
  }

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setSelectedFolder(acceptedFiles[0]);
    }
  }

  const { getRootProps, getInputProps } = useDropZone({
    onDrop,
    multiple: false,
  });
*/
  const onChange = (event) => {
    console.log('file', event.target.value)
    setSelectedFile(event.target.value);

  }

  const handleSubmit = (event) => {
    event.prevenDefault();
    console.log('file tänne tultiin')
  }


  console.log('save file form')
  return (
    <Modal
      size="sm"
      show={show}
      >
      <Modal.Header closeButton>
        <Modal.Title>
          Save
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

      <Form >
      <Form.Group controlId="saveFileLocation" className="mb-3" >
        <Form.Label>Save database file as csv<br/>(Note! Default download folder).</Form.Label>
        <Form.Control id="filename" onChange={onChange} />
      </Form.Group>

      <Form.Group controlId="saveFileType">
        <Form.Label>Select</Form.Label>
        <Form.Check type="radio" value="accelerometer" label="Accelerometer" onChange={handleSaveFileTypeChange} checked={saveFileType === "accelerometer"}></Form.Check>
        <Form.Check type="radio" value="inclinometer" label="Inclinometer" onChange={handleSaveFileTypeChange} checked={saveFileType === "inclinometer"}></Form.Check>
      </Form.Group>

      </Form>
      </Modal.Body>

  <Modal.Footer>
    <Button className="btn btn-primary" onClick={onCancel}  style={{backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }}>Cancel</Button>
    <Button className="btn btn-primary" onClick={apply} style={{backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }}>Apply</Button>
    {/*<Button className="btn btn-primary" onClick={applyRange} >Apply</Button>*/}
  </Modal.Footer>

  </Modal>

  )

/* Otettu inclinometer max100 pois käytöstä toistaiseksi
      <Form.Group controlId="saveFileType">
        <Form.Label>Select</Form.Label>
        <Form.Check type="radio" value="accelerometer" label="Accelerometer" onChange={handleSaveFileTypeChange} checked={saveFileType === "accelerometer"}></Form.Check>
        <Form.Check type="radio" value="inclinometer" label="Inclinometer" onChange={handleSaveFileTypeChange} checked={saveFileType === "inclinometer"}></Form.Check>
        <Form.Check type="radio" value="inclinometer_max100" label="Inclinometer Max 100" onChange={handleSaveFileTypeChange} checked={saveFileType === "inclinometer_max100"}></Form.Check>        
      </Form.Group>
*/  
}


function App() {
  const [selectedRange, setSelectedRange] = useState('24h');
  const [selectedRefresh, setSelectedRefresh] = useState('Off');
  let startTime = new Date();
  startTime.setHours(startTime.getHours() - 24);
  const [selectedBeginTime, setSelectedBeginTime] = useState(startTime.toISOString());
  const [selectedEndTime, setSelectedEndTime] = useState(new Date().toISOString());
  const [selectedDevice, setSelectedDevice] = useState(0); // Testattava laite
  const [selectedDeviceTitle, setSelectedDeviceTitle] = useState('7786373 - HEIPPA'); // Testattava laite
  const [selectedDeviceLocation, setSelectedDeviceLocation] = useState(0); // TODO: location kuuluisi laitteen tietoihin suoraan

  const [selectedFftBeginTime, setSelectedFftBeginTime] = useState(null);
  const [selectedFftEndTime, setSelectedFftEndTime] = useState(null);

  // Kuvat
  const [imageList, setImageList] = useState(null);
  const [selectedImage, setSelectedImage] = useState('3-light-tight.png');
  const [selectedImageSite, setSelectedImageSite] = useState('all');
  const [selectedImageUser, setSelectedImageUser] = useState('all');

  // Käyttäjienhallinta
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [user, setUser] = useState('');


  // Localstorageen tallennetut käyttäjätiedot
  useEffect(() => {
    const loggedUserJSON = window.localStorage.getItem('loggedUser');
    if (loggedUserJSON) {
      const user = JSON.parse(loggedUserJSON);
      setUser(user);


      // Dropboxiin valmiiksi - TESTATAAN
      if (user.username === 'vayla' || user.username === 'helil' || user.username === 'janik' || user.username === 'arsal') {
        setSelectedDevice('7786373');
      }
      else if (user.username === 'metsafibre' || user.username === 'afry') {
        setSelectedDevice('7786370');
      }
      else if (user.username === 'sweco' || user.username === 'rauma') {
        setSelectedDevice('7786370');
      }
      else if (user.username === 'finavia' || user.username === 'htj' || user.username === 'ramboll') {
        setSelectedDevice('7788611');
      }
      else if (user.username === 'pasila' || user.username === 'micael.westerholm@haahtela.fi') {
        setSelectedDevice('7788604');
      }
      else if (user.username === 'keskio' || user.username === 'mikael.vahtera@afry.com' || user.username === 'janne.kauppi@op.fi' || user.username === 'taina.kuismin@htj.fi' || user.username === 'tero.kuikka@htj.fi') {
        setSelectedDevice('7788602');
      }
      else {
        setSelectedDevice('7786373');
      }
    }

  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    console.log('loggin in with', username, password)

    try {
      const user = await loginService({
        username, password
      })

      window.localStorage.setItem(
        'loggedUser', JSON.stringify(user)
      );
      console.log('login - handlelogin user:', user)

      
      setUser(user);
      setUsername('');
      setPassword('');

      // Dropboxiin valmiiksi - TESTATAAN
      if (user.username === 'vayla' || user.username === 'helil' || user.username === 'janik' || user.username === 'arsal') {
        setSelectedDevice('7786373');
      }
      else if (user.username === 'metsafibre' || user.username === 'afry') {
        setSelectedDevice('7786370');
      }
      else if (user.username === 'sweco' || user.username === 'rauma') {
        setSelectedDevice('7786370');
      }
      else if (user.username === 'finavia' || user.username === 'htj' || user.username === 'ramboll') {
        setSelectedDevice('7788611');
      }
      else if (user.username === 'pasila' || user.username === 'micael.westerholm@haahtela.fi') {
        setSelectedDevice('7788604');
      }
      else if (user.username === 'keskio' || user.username === 'mikael.vahtera@afry.com' || user.username === 'janne.kauppi@op.fi' || user.username === 'taina.kuismin@htj.fi' || user.username === 'tero.kuikka@htj.fi') {
        setSelectedDevice('7788602');
      }
      else {
        setSelectedDevice('7786373');
      }


    } catch (exception) {
      console.log('error wrong credentials')
    }
  }

  const loginForm = () => (
    <>
    <div className="loginform-container">
    <form onSubmit={handleLogin}>

      <div className="loginlogo" >
      </div>

      

      <div>
        
        <input 
          type="text"
          value={username}

          placeholder='Username'
          name="Username"
          onChange={({ target }) => setUsername(target.value)}
        />
      </div>
      <div>
        
        <input 
          type="password"
          value={password}
          placeholder="Password"
          name="Password"
          onChange={({ target }) => setPassword(target.value)}
        />
      </div>
      <button className="btn btn-primary" type="submit" style={{marginTop: '10px', backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }} >login</button>
    </form>
    </div>
    </>
  )



  // Aikarajausruutu
  const [rangeModalShow, setRangeModalShow] = useState(false);
  const showRangeModalForm = () => {
    console.log('showModal', rangeModalShow)
    setRangeModalShow(!rangeModalShow);
  }

  const [saveFileModalShow, setSaveFileModalShow] = useState(false);
  const showSaveFileModalForm = () => {
    setSaveFileModalShow(!saveFileModalShow);
  }

  const [mapModalShow, setMapModalShow] = useState(false);
  const showMapModalForm = () => {
    setMapModalShow(!mapModalShow);
  }

  // Dark / Light theme
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  const toggleTheme = () => {
    let newTheme = (theme === 'light') ? 'dark' : 'light';
    setTheme(newTheme);
    
    //asetus(selectedRange, selectedRefresh, newTheme); // Hakee teeman väriset Grafana-paneelit
    populateCharts(selectedDevice, selectedBeginTime, selectedEndTime, selectedRange, selectedRefresh, newTheme);
  }


  // Käyttäjän kohteelle antamat kuvat ja dokumentit 
  const [imageModalShow, setImageModalShow] = useState(false);
  const showImageModalForm = () => {
    setImageModalShow(!imageModalShow)
  }

  // Admin / config sivut
  const [configShow, setConfigShow] = useState(false);
  const showConfig = () => {
    console.log('showconfig:', configShow)
    setConfigShow(!configShow)
  }

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
  }, [theme]);
  // .. Dark / Light theme



  useEffect(() => {
    console.log('app starting..', selectedDevice,selectedBeginTime, selectedEndTime)
    populateCharts(selectedDevice, selectedBeginTime, selectedEndTime, selectedRange, selectedRefresh, theme);;
   
    // TODO: OTA TÄMÄ KÄYTTÖÖN HETI KUN MUUTEN TOIMII!!
    //fftResults(selectedDevice, selectedBeginTime, selectedEndTime);

    //mainForm();
     
    // Alkuasetuksia...
    updateDeviceLocation(selectedDevice);

    fetchImageListFromBackend();

  }, []);

  const [panel10, setPanel10] = useState(null); // Tilt detect
  const [panel11, setPanel11] = useState(null); // Tilt detect list
  const [panel1, setPanel1] = useState(null); // Accelerometer
  const [panel2, setPanel2] = useState(null); // Inclinometer
  const [panel3, setPanel3] = useState(null);
  const [panel4, setPanel4] = useState(null);
  const [panel5, setPanel5] = useState(null);
  const [panel6, setPanel6] = useState(null);
  const [panel7, setPanel7] = useState(null);
  const [panel8, setPanel8] = useState(null);
  const [panel9, setPanel9] = useState(null);
  const [panel26, setPanel26] = useState(null); // Accelerometer mm/s^2
  const [panel27, setPanel27] = useState(null); // Accelerometer datasta testejä (RMS, FFT, etc.)

  // Angles kokoelmat usealta anturilta
  const [panel12, setPanel12] = useState(null); // Kirjalansalmi
  const [panel13, setPanel13] = useState(null); // Rauma
  const [panel14, setPanel14] = useState(null); // Metsäfibre
  const [panel15, setPanel15] = useState(null); // Finavia

  //const asetus = (aika, refresh, newTheme=theme) => {
    //  const asetus2 = (startDate, endDate, newTheme=theme) => {
      //console.log('valittu laite', device, 'start:',beginTime, 'end:',endTime, 'range:',selectedRange, 'refresh:',selectedRefresh, 'theme:', theme);
  // valittu laite 7786394 start: 8.1.2024 end: 26.1.2024 range: null refresh: Off theme: dark
  const populateCharts = (device, start, end, range, refresh, newtheme=theme) => {

    // Huom! username näyttää olevan tyhjä, mutta user sisältää token ja username
    console.log('populatecharts test range', range, start, end, user, username, ' USERNAME=', username, '/', user?.username)
    // device, beginTime, endTime, selectedRange, selectedRefresh, theme
    let new_refresh = (refresh != 'Off') ? '&refresh=' + refresh : '';
    // 2
    //let refresh = ''; //'&refresh=' + '';

    // TODO: Tähän aikarajoituksia sen mukaan missä kohteessa laitteet ovat olleet kyseisenä hetkenä
    //if (user)
    const current_user = user?.username;

    let range_start = null; 

    // TODO: Tämä omaan funktioon
    if (current_user === 'keskio' || 
      current_user === 'mikael.vahtera@afry.com' || current_user === 'janne.kauppi@op.fi' ||
      current_user === 'taina.kuismin@htj.fi' || current_user === 'tero.kuikka@htj.fi') {
      const alku = new Date("2026-03-01T00:00:00");//.toISOString();
      //const loppu = new Date("2026-03-31T23:59:59")//;.toISOString();
      console.log('populate test:', current_user, start, end, '=>', alku, ' // ', range)

      if (start < alku)
        start = alku;

      //if (end > loppu)
      //  end = loppu;
      let test_range_unit = (range) ? range.slice(-1) : null;
      let test_range_value = (range) ? Number(range.slice(0,-1)) : null;

      let test_range_alku = null;

      let test_alku = null;

      if (test_range_unit && test_range_value) {
        if (test_range_unit === 'd')
          test_range_alku = test_range_value * 24 * 60 * 60 * 1000;

        if (test_range_unit === 'h')
          test_range_alku = test_range_value * 60 * 60 * 1000;

        if (test_range_unit === 'm')
          test_range_alku = test_range_value * 60 * 1000;

        test_alku = new Date(Date.now() - test_range_alku);

        if (test_alku < alku)
          range_start = alku;

      }

      console.log('populate start=', start, 'end=', end, test_range_value, test_range_unit, test_alku)

      //const range_alku = (range) ? new Date(Date.now() - )

    }

    

    // TODO: let from 
    var  from = '';
    if (range == null) {
      let start_ms = new Date(start).getTime();
      let end_ms = new Date(end).getTime();
      //let start_ms = 1706189294000;
      //let end_ms = 1706189310000;

      from = `${start_ms}&to=${end_ms}`;     
      console.log('from', from) 
    }
    else {
      // Jos laitteita siirretty toiseen paikkaan, ei voida näyttää toisessa sijainnissa olleita mittauksia
      if (range_start) {
        let start_ms = new Date(range_start).getTime();
        from = `${start_ms}&to=now`;
      }
      // Alkuperäinen 
      else
        from = `now-${range}&to=now`;
    }


    // Kiihtari
    //let aseta = `http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=8&theme=${newtheme}&var-sensorid=${device}`;
    //let aseta = `https://opus.iottech.fi/grafana/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=8&theme=${newtheme}&var-sensorid=${device}`;
    let aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=8&theme=${newtheme}&var-sensorid=${device}`;
    
    console.log('aseta', aseta)
    setPanel1(aseta);

    // Tilt
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=9&theme=${newtheme}&var-sensorid=${device}`;
    setPanel2(aseta);

    // fft painavin taajuus
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=12&theme=${newtheme}&var-sensorid=${device}`;
    setPanel3(aseta);

    // fft taajuudet
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=13&theme=${newtheme}&var-sensorid=${device}`;
    setPanel4(aseta);

    // fft painot
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=14&theme=${newtheme}&var-sensorid=${device}`;
    setPanel5(aseta);

    // fft:n aikainen kiihtari
    //let teststart = 1706189294000;
    //let testend = 1706189310000;
    let teststart = selectedFftBeginTime;
    let testend = selectedFftEndTime;
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&from=${teststart}&to=${testend}&panelId=8&theme=${newtheme}&var-sensorid=${device}`;
    console.log('setpanel6', aseta)
    setPanel6(aseta);

    // Inclinometer - Max 50
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=16&theme=${newtheme}&var-sensorid=${device}`;
    setPanel7(aseta);

    // Inclinometer - Min 50
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=17&theme=${newtheme}&var-sensorid=${device}`;
    setPanel8(aseta);

    // Muut kuten location, temp, hum etc.
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=15&theme=${newtheme}&var-sensorid=${device}`;
    setPanel9(aseta);


    // Tilt detect
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=18&theme=${newtheme}&var-sensorid=${device}`;
    setPanel10(aseta);

    // Tilt detect table
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=19&theme=${newtheme}&var-sensorid=${device}`;
    setPanel11(aseta);

    // Angles Kokoelmat
    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=21&theme=${newtheme}&var-sensorid=${device}`;
    setPanel12(aseta); // Kirjalansalmi

    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=22&theme=${newtheme}&var-sensorid=${device}`;
    setPanel15(aseta); // Finavia

    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=24&theme=${newtheme}&var-sensorid=${device}`;
    setPanel14(aseta); // Metsäfibre

    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=25&theme=${newtheme}&var-sensorid=${device}`;
    setPanel13(aseta); // Rauma

    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=26&theme=${newtheme}&var-sensorid=${device}`;
    setPanel26(aseta); // Accelerometer mm/s^2

    aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1${new_refresh}&from=${from}&panelId=27&theme=${newtheme}&var-sensorid=${device}`;
    setPanel27(aseta); // Accelerometer datasta testejä (RMS, FFT, etc.)

  }

  // FFT on poikkeus chart, jota päivitetään aina kun valittu fft muuttuu
  const updateFftChart = (device, beginTime, endTime) => {
    let refresh = selectedRefresh;
    let newtheme = theme;
    //let device = selectedDevice;
    let aseta = `${grafana_url}/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&from=${beginTime}&to=${endTime}&panelId=8&theme=${newtheme}&var-sensorid=${device}`;
    console.log('setpanel6-test', aseta)
    setPanel6(aseta);
  }

  const databaseQuery = async (filename, filetype) => {
    let type = filetype.toLowerCase();
    //let type = 'accelerometer';

    let url = `${iottech_url}/database?sensor=${selectedDevice}&begin=${selectedBeginTime}&end=${selectedEndTime}&type=${type}`
    await fetch(url, {
      method: "GET",
      headers: {
        'Content-Type': 'application/csv'
      },      
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${filename}_${type}.csv`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    })

  }

  const saveFromDatabase = (filename,filetype) => {
    console.log('saveFromDatabase', filename, filetype, selectedDevice, selectedBeginTime, selectedEndTime)
    
    //http://51.15.114.61:8086/api/v2/query?org=iottech 
    //-H 'Authorization: Token _gzbhFQFAwaLeqzib1e0ylgrHjTmxfgX-UbURBfnxT80kgM07dkk2ynhfMksf1kyt98KXC9TJNw4D6kpFVEEjA==' 
    //-H 'Accept:application/csv' 
    //-H 'Content-type:application/vnd.flux' 
    //-d 'from(bucket:"level") |> range(start: -3d) |> aggregateWindow(every: 24h, fn: mean) |> drop(columns: ["_start", "_stop", "_result"])'

    //curl "http://51.15.114.61:8086/api/v2/query?org=iottech" -H "Authorization: Token _gzbhFQFAwaLeqzib1e0ylgrHjTmxfgX-UbURBfnxT80kgM07dkk2ynhfMksf1kyt98KXC9TJNw4D6kpFVEEjA==" -H "Accept:application/csv" -H "Content-type:application/vnd.flux" -d 'from(bucket:"level") |> range(start: 2023-11-07T20:50:00Z, stop: 2023-11-07T22:15:00Z) |> filter(fn: (r) => r._measurement == "accelerometer" and r.sensor_id == "7786394") |> pivot(rowKey:["_time"], columnKey: ["_field"], valueColumn: "_value") ' --output data_7786394.csv


    console.log('fetch')
    databaseQuery(filename, filetype);
    //databaseQuery(filename, 'inclinometer');
    //databaseQuery(filename, 'inclinometer_max100');
    //fetch("http://172.16.0.103:7095/database", {
      
      //fetch("http://51.15.114.61:7095/database", {
    /*        
      fetch("http://51.15.114.61:7095/database", {
      method: "GET",
      headers: {
        'Content-Type': 'application/zip'
      },      
      */
    // TODO: Tyyppi accelerometer / inclinometer / 
    /*
    let type = 'accelerometer';

     let url = `${iottech_url}/database?sensor=${selectedDevice}&begin=${selectedBeginTime}&end=${selectedEndTime}&type=${type}`
     fetch(url, {
      method: "GET",
      headers: {
        'Content-Type': 'application/csv'
      },      
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${filename}_acc.csv`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    })

    .then(() => {

      // ---------------------

      // Tässä testataan eri tyyppisiä hakuja ja tiedostoon tallennukseen 
      type = 'inclinometer';

      url = `${iottech_url}/database?sensor=${selectedDevice}&begin=${selectedBeginTime}&end=${selectedEndTime}&type=${type}`
        fetch(url, {
        method: "GET",
        headers: {
          'Content-Type': 'application/csv'
        },      
      })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${filename}_inc.csv`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });

    });
*/



    // ---------------------

  
    /*
    let fileURL = 'test.pdf';
    fetch('https://cors-anywhere.herokuapp.com/' + fileURL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
        'Access-Control-Allow-Origin: *'
      },
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `FileName.pdf`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
    */
  }

  const onSelectDevice = (device) => {
    console.log('valittu laite', device, 'start:',selectedBeginTime, 'end:', selectedEndTime, 'range:',selectedRange, 'refresh:',selectedRefresh, 'theme:', theme);
    setSelectedDevice(device);
    setSelectedDeviceTitle(device + ' TESTING')
    populateCharts(device, selectedBeginTime, selectedEndTime, selectedRange, selectedRefresh, theme);
    fftResults(device, selectedBeginTime, selectedEndTime);//!!
    updateDeviceLocation(device);
  }

  const applyRange = (event) => {
    console.log('applyRange', event)
    setRangeModalShow(false);

    // Käytetään viimeisimpiä mittauksia jos se on annettuna
    if (event.selectedRange) {
      //asetus(event.selectedRange, event.selectedRefresh);
      setSelectedRange(event.selectedRange);
      setSelectedRefresh(event.selectedRefresh);
      console.log('applyrange-test:', event);
      //populateCharts(event.selectedRange);
      
      // Lasketaan rangen perusteella alku ja loppuajat
      let end = new Date().toISOString();
      let begin = moment(end).subtract(1, 'days').toISOString();
      console.log('selectedrange', event.selectedRange, selectedBeginTime, selectedEndTime, '->', begin, end);


      
      
      populateCharts(selectedDevice, selectedBeginTime, selectedEndTime, event.selectedRange, event.selectedRefresh, theme);
      fftResults(selectedDevice, begin, end);
    }
    else {
      // Nollataan myös last mittauksia
      setSelectedRange(null);
      //asetus2(event.startDate, event.endDate);
      //populateCharts(null);
      let begin = new Date(event.selectedStartDate).toISOString();
      let end = new Date(event.selectedEndDate).toISOString();
      console.log('range', event.selectedStartDate, event.selectedEndDate)
      setSelectedBeginTime(begin);
      setSelectedEndTime(end);



      populateCharts(selectedDevice, event.selectedStartDate, event.selectedEndDate, null, selectedRefresh, theme);
      fftResults(selectedDevice, event.selectedStartDate, event.selectedEndDate);
    }
  }

  const onCancelRange = () => {
    setRangeModalShow(false);
  }


  const applySaveFile = (event) => {
    setSaveFileModalShow(false);
    console.log('file event', event)
    //alert('heippa' + event.filename)
    let filename = event.filename;
    let filetype = event.filetype;
    saveFromDatabase(filename, filetype);
    
  }

  const onCancelSaveFile = () => {
    setSaveFileModalShow(false);
  }

  const onMapClose = () => {
    setMapModalShow(false);
  }

  const iframeTest = () => {
    console.log('iframe clicked')
  }

  const onImageClose = () => {
    setImageModalShow(false);
  }



  // Avaa karttanäkymän
  // Vanha JY apikey: AIzaSyBdYYh8A_eanLza5ULueKeemQxwAeJ1iZk
  const MapModalForm = ({show, onClose, theme}) => {
    const position = selectedDeviceLocation ? selectedDeviceLocation : { lat: 61.68713, lng: 27.27047 }; //{ lat: 61.68713, lng: 27.27047 };
    console.log('mapmodalform position', position)
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState("");

    return (
      <Modal
      size="xl"
      show={show}
      >

      <Modal.Body>
      <APIProvider apiKey={"AIzaSyAPlS78wBR4M--706zhvPTuw9NZ6f7ttv0"}>
        <div style={{height: "85vh"}}>

          <Map zoom={12} center={position} mapId="d4431eac82eb3ca9">
            <AdvancedMarker position={position} onClick={() => { setOpen(true); setInfo("IotTech HQ, Mikkeli, Finland") }}>
              <Pin
                background={"#ce7e00"}
                borderColor={"white"}
                glyphColor={"#000000"}
              />
            </AdvancedMarker>
            {open && (
              <InfoWindow position={position} onCloseClick={() => {setOpen(false); setInfo("");}}>
                <p style={{color: 'black'}}>{selectedDevice}</p>
              </InfoWindow>
            )}
          </Map>


        </div>
      </APIProvider>
      </Modal.Body>
      <Modal.Footer>
        <p>{info}</p>
        <Button className="btn btn-primary" onClick={onClose} style={{backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }} >Close</Button>
      </Modal.Footer>
      </Modal>
    )
  }


/*
  const FileUpload = () => {
    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
      setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await axios.post(iottech_url + '/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(response.data);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    };

    return (
      <form onSubmit={handleSubmit}>
        <input className="floppy"  type="file" onChange={handleFileChange} />
        <button type="submit">Upload!</button>
      </form>
    );
  }
*/

/* testiä varten - poista
const images = [
  {
    original:  'http://127.0.0.1:7095/siteimages/1746451156639.jpg',
    thumbnail: 'http://127.0.0.1:7095/siteimages/1746451156639.jpg'
  },
  {
    original:  'http://127.0.0.1:7095/siteimages/1746451156639.jpg',
    thumbnail: 'http://127.0.0.1:7095/siteimages/1746451156639.jpg'
  },
];
*/








//-----------------------------------------------------------------------------------------------

  // Hakee backendistä kuvalistan ja asettaa listan imageListiin ja uusimman kuvan valituksi kuvaksi, selectedImage
  const fetchImageListFromBackend = () => {
    // Kuvalista
    // TODO: Siirrä omaan funktioonsa
    axios.get(iottech_url + '/imagelist')
      .then((response) => {
        console.log('imagelist response:',response.data);    
        
        if (response.data.length > 0) {
          // Näkyviin viimeisin kuva
          setSelectedImage(response.data[response.data.length-1]);
          console.log('setImageList:', response.data.length, '/', response.data[response.data.length-1]['file']['filename'])

          // Lisätään jokaiselle kuvalle origin ImageGallery komponenttia varten. Siinä polkuineen osoite, josta kuva löytyy.
          // TODO: Poista. Tämä ei tullutkaan käyttöön
          //response.data.forEach(element => {
          //  element['original'] = iottech_url + '/siteimages/' + element['file']['filename'];
          //  console.log('element', element)
          //})

          // Asetetaan ImageList myös tyhjänä
          setImageList(response.data);
          console.log('imagelist', response.data)

        }


      })

  }

 // KUVIEN LISÄYS/POISTO...
  // Avaa Kuvanäkymän
  // Vanha JY apikey: AIzaSyBdYYh8A_eanLza5ULueKeemQxwAeJ1iZk
  const ImageModalForm = ({show, onClose, theme}) => {
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState("");
    
    //const [imageSite, setImageSite] = useState("test");
    //const [imageDevice, setImageDevice] = useState("");

    const [showUpload, setShowUpload] = useState(false);

    //const [imageFilename, setImageFilename] = useState("")

    // Tiedoston uploadaus
    const [file, setFile] = useState(null);
    const [description, setDescription] = useState(null); // Käytetään käyttöliittymässä 

    // 1. Choose file -> valittu kuva -> Open
    const handleFileChange = (e) => {
      console.log('image handleFileChange:', e.target.files[0])
      setFile(e.target.files[0]);

      // e.target.files[0]
      //  ['lastModified']: 1212071878000
      //  ['lastModifiedDate']: Thu May 29 2008 17:37:58 GMT+0300 (Eastern European Summer Time) {}
      //  ['name']: "IMG_3385.JPG"
      //  ['size']: 1536445
      //  ['type']: "image/jpeg"
      //  ['webkitRelativePath']: ""

    };

    // 2. Kuva valittuna ja nimi lukee edit-kentässä -> Painetaan Upload
    const handleSubmit = async (e) => {
      e.preventDefault();

      // Asetetaan lisätietoa backendille lähetettäväksi
      //const newFileInfo = { ...file };
      //newFileInfo['description'] = description;

      //file['description'] = description;
      //setFile(newFileInfo);

      console.log('selected user:', selectedImageUser)
      console.log('selected site:', selectedImageSite)
      //console.log('selected device:', selectedImageDevice)
      //return;


      const formData = new FormData();
      formData.append('file', file);
      console.log('image handleSubmit:', file)
      //console.log('image handleSubmit2:', newFileInfo)

      //const device = '7785075';
      
      
      formData.append('description', e.target.description.value);
      //formData.append('device', imageDevice);
      formData.append('user', selectedImageUser);
      formData.append('site', selectedImageSite);

      
      //console.log('submit get description:', e.target.description.value, ' / filename:', e.target.filename.value)

      setDescription(e.target.description.value);


      

      console.log('image test:', file['name'])
      // file:
      //  ['lastModified']: 1212092212000
      //  ['name']: "IMG_3417.JPG"
      //  ['size']: 982105
      //  ['type']: "image/jpeg"
      //  ['lastModifiedDate']: Wed May 28 2008 22:35:14 GMT+0300 (Eastern European Summer Time) {}

      
      try {
        // 3. Kuva uploadattu backendiin -> saadaan vastaus
        const response = await axios.post(iottech_url + '/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log('image response:',response.data);


        // Onnistunut uploadaus
        
        //response.data['message']: "File uploaded successfully"   <- tämän lähettä backend

        // response.data['file']
        //   ['destination']: "uploads/"
        //   ['encoding']: "7bit"
        //   ['fieldname']: "file"
        //   ['filename']: "1739530869462.png"
        //   ['mimtetype']: "image/png"
        //   ['originalname']: "Screenshot 2024-03-28 132556.png"
        //   ['path']: "uploads/1739530869462.png"
        //   ['size']: 878080


        // Asetetaan uploadattu kuva samantien näkyviin
        //setImageFilename(response.data['file']['filename']);
        // Nämä on setImageFilenamen kanssa päällekkäisiä
        //setSelectedImage(response.data['file']['filename']);
        //!!!setSelectedImage(response.data);
        // Pitäisi laittaa hakuun kaikki kuvat uudestatan
        console.log('setImageFilename:', response.data['file']['filename'])
      

      } catch (error) {
        console.error('Error uploading file:', error);
      }

      setShowUpload(false);
      console.log('image closing upload form')

      // Haetaan kaikki kuvat uudestaan
      fetchImageListFromBackend();


      // TODO: 
      // 4. Lähetetään backendille muut tiedot kuvasta: 
      //      - user
      //      - seliteteksti
      //      - kohdetunnus (site id, device id)
      //      - tallennetun kuvan nimi (saatiin vastauksena kun tultiin tänne)
      // Backend tallentaa omaan "tietokantaansa" nämä tiedot, joiden perusteella näyttää käyttäjä/kohdekohtaisesti kuvat
      // TODO:
      // 5. Mahdollisuus vaihtaa/poistaa kuvat lisäyksen lisäksi.


    };
/*
    return (
      <form onSubmit={handleSubmit}>
        <input type="file" onChange={handleFileChange} />
        <button type="submit">Upload</button>
      </form>
    );
*/

    const onApplySite = (valinta) => {
      console.log('Site valittu:', valinta)
      //setImageDevice(valinta);
      setSelectedImage(null);
      setSelectedImageSite(valinta);
    }

    const onApplyUser = (valinta) => {
      console.log('User valittu:', valinta)
      //setImageDevice(valinta);
      setSelectedImage(null);
      setSelectedImageUser(valinta);
    }


    // const onApply = (valinta) => {
    //   console.log('image valittu:', valinta)
    //   setImageDevice(valinta);

    // }


    //const position = selectedDeviceLocation ? selectedDeviceLocation : { lat: 61.68713, lng: 27.27047 }; //{ lat: 61.68713, lng: 27.27047 };
    //console.log('ImageModalForm position', position)

    //console.log("HOST = {host}")
    //<img src="http://127.0.0.1:7095/kirjalansalmi/kirjalansalmi.png" width="90%" alt="React Image" />
    console.log('image user:', user, ' username:', user['username'])

    //var url = iottech_url + "/kirjalansalmi/kirjalansalmi.png"
    var url = iottech_url + "/siteimages/";

    // Tämän tilalle listan viimeinen: <img src={iottech_url + "/kirjalansalmi/" + imageFilename} width="90%" alt="React Image" />
    //<img src={imageList && imageList[0] && imageList[0]['file'] && imageList[0]['file']['filename'] && iottech_url + "/siteimages/" + imageList[0]['file']['filename']} width="90%" alt="React Image" />


    //selectedImage && selectedImage['file'] && selectedImage['file']['filename'] &&
    //<img src={url + selectedImage['file']['filename']} width="90%" alt="React Image" />

//            <label>{selectedImage && selectedImage['description']}</label>
//<ImageGallery items={imageList} startIndex={imageList.length-1} lazyLoad={false} />

{/* <ListGroup>
<ListGroup.Item>imageList</ListGroup.Item>
<ListGroup.Item>Toinen</ListGroup.Item>
<ListGroup.Item>Kolmas</ListGroup.Item>
</ListGroup>               */}

    return (
      <Modal
      size="xl"
      show={show}
      >
      <Modal.Body>

        <Container className="mt-4"> 
          <Row>
            <Col md={8}>
              <div className="siteimage" style={{ padding: '5px' }} >
                {selectedImage && selectedImage['file'] &&
                  <img src={selectedImage && selectedImage['file'] && iottech_url + "/siteimages/" + selectedImage['file']['filename']} class="img-fluid"></img> 
                }
                {!selectedImage &&
                  <img src={iottech_url + '/' + '3-light-tight.png'} class="img-fluid"></img> 
                }
              </div>          
            </Col>

            <Col md={4}>

            <Row>
              <Col md={3}>
              User
              </Col>
              <Col md={9}>
            <Dropdown> 
              <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
                {users[selectedImageUser]}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {
                  Object.entries(users).map(([id, name]) => {
                  return (
                     <Dropdown.Item
                       key={id}
                       name={name}
                       style={{ cursor: 'pointer' }}
                       onClick={() => onApplyUser(id)}>
                       {name}
                     </Dropdown.Item> 
                  )
                })}

              </Dropdown.Menu>
            </Dropdown>
            </Col>
            </Row>

            <Row>
              <Col md={3}>
              <label>Site</label>
              </Col>
              <Col md={9}>
            <Dropdown> 
              <Dropdown.Toggle className="col-12 mx-auto" variant="warning" id="dropdown-basic">
                {sites[selectedImageSite]}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {
                  Object.entries(sites).map(([id, name]) => {
                  return (
                     <Dropdown.Item
                       key={id}
                       name={name}
                       style={{ cursor: 'pointer' }}
                       onClick={() => onApplySite(id)}>
                       {name}
                     </Dropdown.Item> 
                  )
                })}



              </Dropdown.Menu>
            </Dropdown>
            </Col>
            </Row>

            <Row>

              <ListGroup style={{ minHeight: '300px', maxHeight: '300px', minWidth: '100px', overflowY: 'auto', marginTop: '10px' }}>

                {imageList && imageList.length > 0 && 
                  imageList
                  .filter(item => selectedImageUser === 'all' || item.user === selectedImageUser)
                  .filter(item => selectedImageSite === 'all' || item.site === selectedImageSite)
                  .map((item, index) => {
                  console.log('item:', item, ' index:', index)
                  return (
                    <ListGroup.Item 
                      key={item.file.filename} 
                      name={item.file.filename} 
                      style={{ cursor: 'pointer' }}
                      onClick={() => setSelectedImage(item)}>
                        {item.description}
                    </ListGroup.Item>
                  )
                })}
                
              </ListGroup>      

              </Row>

            </Col>
          </Row>

        </Container>

      </Modal.Body>
        <Modal.Footer>

          <Container className="mt-4">



            {/* Footer Normaali */}
            {!showUpload &&
              <>

                <Col md={4}>
                  <p>{
                    selectedImage && selectedImage['description']
                  }
                  </p>
                </Col>

                <Col md={8} className="d-flex justify-content-end">

                  <Button className="btn btn-primary mx-2" style={{ backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }} onClick={() => { setShowUpload(!showUpload) }}>Add</Button>
                  <Button className="btn btn-primary ml-1" onClick={onClose} style={{ backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }} >Close</Button>

                </Col>
              </>
            }

            {/* Footer editointi */}
            {showUpload &&

              <Col md={12} className="d-flex justify-content-center">

                <form show={false} onSubmit={handleSubmit} style={{ backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }}>
                  {/* User */}


                  {/* Site */}

                  {/* Device */}
                  {/* <Dropdown>
                    <Dropdown.Toggle className="col-4 mx-auto" variant="warning" id="dropdown-basic">
                      {"Device"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => onApply('7785075')}>7785075</Dropdown.Item>
                      <Dropdown.Item onClick={() => onApply('7786393')}>7786393</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}



                  <input type="file" name="filename" className="mr-1" style={{ marginRight: '10px' }} onChange={handleFileChange} />
                  <label className="mr-1" style={{ marginRight: '10px' }}>
                    Description
                    <input name="description" style={{ marginRight: '10px' }} />
                  </label>
                  <button className="mr-1" type="submit" style={{ backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }}>Upload</button>
                  <button className="mr-1" type="button" style={{ backgroundColor: "#ce7e00", color: "black", borderColor: "#ce7e00" }} onClick={() => {setShowUpload(!showUpload)}}>Cancel</button>
                  
                </form>

              </Col>
            }




          </Container>
        </Modal.Footer>
      </Modal>
    )
  }  
 // ... KUVIEN LISÄYS/POISTO


 // CONFIG / ADMIN
 const ConfigModalForm = ({show, onClose, theme}) => {
  const [info, setInfo] = useState("");

  let query = `${iottech_url}/api`;
  console.log('query', query)
/* TODO: Tämä alkoikin hakkaamaan tätä loopissa. Koitetaan parempaa tapaa

  //fetch("http://172.16.0.103:7095/fft?sensor=7786394&begin=1704481524&end=1706189310")
  //fetch("http://51.15.114.61:7095/fft?sensor=7786394&begin=1704481524&end=1706469306")
  fetch(query)
  //fetch("http://127.0.0.1:7095/fft")
  .then((response) => {
    // Create blob link to download
    //console.log('response', response)
    return response;
  })
  .then((data) => { 
    setInfo(data);
//    console.log('fft tulokset:',data)

    //let beginResult = data['begin'];
    //let endResult = data['end'];


    //console.log('aikaikkuna', beginResult, endResult, data);

    //updateFftChart(device, beginResult, endResult);
    //setSelectedFftBeginTime(beginResult);
    //setSelectedFftEndTime(endResult);
  });  

  return (
    <Modal
    size="xl"
    show={show}
    >
    <Modal.Body>

      <h1>Config</h1>
      <p>Under construction</p>
      <p>Coming soon</p>
    </Modal.Body>
      <Modal.Footer>

      </Modal.Footer>
    </Modal>

  )
*/

 }

 const onConfigClose = () => {
  setConfigShow(false);
}

//-----------------------------------------------------------------------------------------------


  // Esim. yksi fft tulos 2024-01-25T13:28:30Z välillä 1706189294000 - 1706189310000, sensorid=7786394
  /* 0
  :
  {freq: '5.8', weight: '0.744'}
  1
  : 
  {freq: '5.43', weight: '0.456'}
  2
  : 
  {freq: '10.8', weight: '0.388'}
  3
  : 
  {freq: '10.99', weight: '0.0953'}
  4
  : 
  {freq: '11.6', weight: '0.0863'}
  5
  : 
  {freq: '4.82', weight: '0.0801'}
  6
  : 
  {freq: '6.04', weight: '0.0675'}
  7
  : 
  {freq: '11.11', weight: '0.0557'} */
  // Hakee fft tulokset backendistä
  // Args: begin, end
  // Kts. https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
  const fftResults = (device, begin, end) => {
    //http://51.15.114.61:8086/api/v2/query?org=iottech 
    //-H 'Authorization: Token _gzbhFQFAwaLeqzib1e0ylgrHjTmxfgX-UbURBfnxT80kgM07dkk2ynhfMksf1kyt98KXC9TJNw4D6kpFVEEjA==' 
    //-H 'Accept:application/csv' 
    //-H 'Content-type:application/vnd.flux' 
    //-d 'from(bucket:"level") |> range(start: -3d) |> aggregateWindow(every: 24h, fn: mean) |> drop(columns: ["_start", "_stop", "_result"])'
    console.log('fetch fft')
    //fetch("http://172.16.0.103:7095/database", {
      
      //fetch("http://51.15.114.61:7095/fft", {
    //fetch("http://127.0.0.1:7095/fft", {
    //  method: "GET",
    //  headers: {
    //    'Content-Type': 'application/json'
    //  },      
    //})
    
    let beginQuery = Math.floor(new Date(begin).getTime() / 1000);
    let endQuery = Math.floor(new Date(end).getTime() / 1000);


    //http://51.15.114.61:7095/fft?sensor=7786394&begin=1695540600000&end=1695627000000





    //let query = `http://51.15.114.61:7095/fft?sensor=${device}&begin=${beginQuery}&end=${endQuery}`;
    let query = `${iottech_url}/fft?sensor=${device}&begin=${beginQuery}&end=${endQuery}`;
    console.log('query', query)

    //fetch("http://172.16.0.103:7095/fft?sensor=7786394&begin=1704481524&end=1706189310")
    //fetch("http://51.15.114.61:7095/fft?sensor=7786394&begin=1704481524&end=1706469306")
    fetch(query)
    //fetch("http://127.0.0.1:7095/fft")
    .then((response) => {
      // Create blob link to download
      //console.log('response', response)
      return response.json();
    })
    .then((data) => { 
      console.log('fft tulokset:',data)

      let beginResult = data['begin'];
      let endResult = data['end'];


      console.log('aikaikkuna', beginResult, endResult, data);

      updateFftChart(device, beginResult, endResult);
      setSelectedFftBeginTime(beginResult);
      setSelectedFftEndTime(endResult);
    });

  }  

  // Päivittää valitun laitteen sijaintitiedot
  const updateDeviceLocation = (device) => {
    let query = `${iottech_url}/location?sensor=${device}`;
    console.log('query', query)

    fetch(query)
    //fetch("http://127.0.0.1:7095/fft")
    .then((response) => {
      // Create blob link to download
      console.log('response', response)
      return response.json();
    })
    .then((data) => { 
      let location = new Object();
      location['lat'] = Number(data['lat']);
      location['lng'] = Number(data['long']);

      if ( isNaN(location['lat']) || isNaN(location['lng']) ) {
        setSelectedDeviceLocation(0);
      }
      else {
        setSelectedDeviceLocation(location);
      }

      console.log('location', location)
    });
  }

/*  
  <div className="logo" style={{padding: '5px' }} >
  <img src={logo} style={{width:'100%' }} align="left" alt="IOTTECH" />
</div>
*/

  const mainForm = () => {
    // Asiakaskohtaiset räätälöinnit
    // TODO: Näihin käyttäjätasot
    if (user.username === 'vayla' || user.username === 'helil' || user.username === 'janik' || user.username === 'arsal') {
      // Dropboxin oletusvalinta      
      //setSelectedDevice('7786373');
      return mainForm_vayla();
    }
    else if (user.username === 'metsafibre' || user.username === 'afry') {
      //setSelectedDevice('7786370');
      return mainForm_metsafibre();
    }
    else if (user.username === 'sweco' || user.username === 'rauma') {
      //setSelectedDevice('7786370');
      return mainForm_rauma();
    }
    else if (user.username === 'finavia' || user.username === 'htj' || user.username === 'ramboll') {
      //setSelectedDevice('7786370');
      return mainForm_finavia();
    }
    else if (user.username === 'pasila' || user.username === 'micael.westerholm@haahtela.fi') {
      return mainForm_pasila_keskitorni();
    }
    else if (user.username === 'keskio' || user.username === 'mikael.vahtera@afry.com' || user.username === 'janne.kauppi@op.fi' || user.username === 'taina.kuismin@htj.fi' || user.username === 'tero.kuikka@htj.fi') {
      return mainForm_keskio();
    }


    // Muuten oletuksena näytetään kaikki
    return (
      <>

      

        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect title={selectedDevice} onApply={onSelectDevice}></DeviceSelect>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" onClick={showConfig} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />

            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />

            <ConfigModalForm width="80%" show={configShow} onClose={onConfigClose} theme={theme} />

          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel10} width="49%" height="200" frameBorder="0"></iframe> 
        <iframe src={panel11} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel1} width="49%" height="200" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel3} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel4} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel5} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel6} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel7} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel8} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel9} width="98%" height="200" frameBorder="0"></iframe>
        <iframe src={panel12} width="98%" height="200" frameBorder="0"></iframe>
        <iframe src={panel13} width="98%" height="200" frameBorder="0"></iframe>
        <iframe src={panel14} width="98%" height="200" frameBorder="0"></iframe>
        <iframe src={panel15} width="98%" height="200" frameBorder="0"></iframe>
        <iframe src={panel26} width="49%" height="200" frameBorder="0"></iframe>
        <iframe src={panel27} width="49%" height="200" frameBorder="0"></iframe>

        {/* Recharts komponentti
        <Chart/>
  */}
{/*
        <div className="logout" style={{ marginRight: '10px' }} >
          <button class="btn btn-primary" type="button" onClick={() => { window.localStorage.removeItem('loggedUser'); setUser('') }}>logout</button>
        </div>
*/}


      </>
    );

  }


  const mainForm_vayla = () => {
    console.log('vayla mainform user', user)

    return (
      <>
        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect_vayla title={deviceTitles[selectedDevice]} onApply={onSelectDevice}></DeviceSelect_vayla>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>
            {/* TODO: Ota kaikille käyttöön kun valmis
            <div className="image" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>
            */}
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />
            {/* TODO: Ota kaikille käyttöön kun valmis
            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />
            */}
          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel10} width="49%" height="400" frameBorder="0"></iframe> 
        <iframe src={panel11} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel1} width="49%" height="400" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="400" frameBorder="0"></iframe>
      </>
    );

  }


  // Metsä fibre ja Afry
  const mainForm_metsafibre = () => {
    console.log('metsäfibre mainform user', user)

    return (
      <>
        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect_metsafibre title={deviceTitles[selectedDevice]} onApply={onSelectDevice}></DeviceSelect_metsafibre>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>
            {/* TODO: Ota kaikille käyttöön kun valmis
            <div className="image" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>
            */}
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />
            {/* TODO: Ota kaikille käyttöön kun valmis
            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />
            */}
          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel10} width="49%" height="400" frameBorder="0"></iframe> 
        <iframe src={panel11} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel1} width="49%" height="400" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="400" frameBorder="0"></iframe>
      </>
    );

  }  

  // ****** rauma
  const mainForm_rauma = () => {
    console.log('rauma mainform user', user)

    return (
      <>
        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect_rauma title={deviceTitles[selectedDevice]} onApply={onSelectDevice}></DeviceSelect_rauma>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>
            {/* TODO: Ota kaikille käyttöön kun valmis
            <div className="image" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>
            */}
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" onClick={showConfig}/>
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />
            {/* TODO: Ota kaikille käyttöön kun valmis}
            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />
            */}
          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel10} width="49%" height="400" frameBorder="0"></iframe> 
        <iframe src={panel11} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel1} width="49%" height="400" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="400" frameBorder="0"></iframe>
      </>
    );

  }  
  // *****rauma


  // ****** finavia
  const mainForm_finavia = () => {
    console.log('finavia mainform user', user)

    return (
      <>
        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect_finavia title={deviceTitles[selectedDevice]} onApply={onSelectDevice}></DeviceSelect_finavia>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>
            {/* TODO: Ota kaikille käyttöön kun valmis
            <div className="image" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>
            */}
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" onClick={showConfig}/>
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />
            {/* TODO: Ota kaikille käyttöön kun valmis}
            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />
            */}
          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel1} width="49%" height="400" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel3} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel4} width="49%" height="400" frameBorder="0"></iframe>
      </>
    );

  }  
  // *****finavia


  // ****** pasila_keskitorni
  const mainForm_pasila_keskitorni = () => {
    console.log('pasila_keskitorni mainform user', user)

    return (
      <>
        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect_pasila_keskitorni title={deviceTitles[selectedDevice]} onApply={onSelectDevice}></DeviceSelect_pasila_keskitorni>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>
            {/* TODO: Ota kaikille käyttöön kun valmis
            <div className="image" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>
            */}
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" onClick={showConfig}/>
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />
            {/* TODO: Ota kaikille käyttöön kun valmis}
            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />
            */}
          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel1} width="49%" height="400" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel3} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel4} width="49%" height="400" frameBorder="0"></iframe>
      </>
    );

  }  
  // *****pasila_keskitorni


  // ****** keskio
  const mainForm_keskio = () => {
    console.log('keskio mainform user', user)

    return (
      <>
        <div className="container">

          <div className="container">

            <div className="logo" style={{ padding: '5px' }} >
              <img style={{ width: '100%' }} align="left" alt="IOTTECH" />
            </div>
          </div>



          <div className="container">
            <div style={{ marginRight: "10px" }}>Time range:</div>
            {(selectedRange !== null)
              ? <div style={{ marginRight: "10px" }}>Last {selectedRange}</div>
              : <div style={{ marginRight: "10px" }}>{moment(selectedBeginTime).format('DD.MM.YYYY HH:mm')} - {moment(selectedEndTime).format('DD.MM.YYYY HH.mm')}</div>}
          </div>

          <div className="container">
            <div style={{ marginRight: "10px" }}>Refresh:</div>
            <div style={{ marginRight: "10px" }}>{selectedRefresh}</div>
          </div>






          {/* Siirrä tämä omaan funktioon */}
          <div className="container">
            <DeviceSelect_keskio title={deviceTitles[selectedDevice]} onApply={onSelectDevice}></DeviceSelect_keskio>
          </div>


          <div className="container">

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={clock} style={{ height: '30px' }} align="left" alt="Select range" onClick={showRangeModalForm} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={floppy} style={{ height: '30px' }} align="left" alt="Save data in csv" onClick={showSaveFileModalForm} />
              {/*<img src={floppy} style={{height:'30px'}} align="left" alt="Save data in csv"  onClick={saveFileForm} /> */}

            </div>
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={brilliance} style={{ height: '30px' }} align="left" alt="Theme" onClick={toggleTheme} />
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={map} style={{ height: '30px' }} align="left" alt="Map" onClick={showMapModalForm} />
            </div>
            {/* TODO: Ota kaikille käyttöön kun valmis
            <div className="image" style={{ padding: '5px' }} >
              <img src={image} style={{ height: '30px' }} align="left" alt="Image" onClick={showImageModalForm} />
            </div>
            */}
            <div className="floppy" style={{ padding: '5px' }} >
              <img src={gear} style={{ height: '30px' }} align="left" alt="Config" onClick={showConfig}/>
            </div>

            <div className="floppy" style={{ padding: '5px' }} >
              <img src={logout} style={{ height: '30px' }} align="left" alt="Logout" Tooltip="test" onClick={() => {window.localStorage.removeItem('loggedUser'); setUser('')}} />
            </div>

            {/*
        <ReactSwitch
          checked={theme}
          onChange={handleChange}
        />
      */}


            <RangeModalForm width="20%" show={rangeModalShow} onApply={applyRange} onCancel={onCancelRange} theme={theme} />
            <SaveFileModalForm width="20%" show={saveFileModalShow} onApply={applySaveFile} onCancel={onCancelSaveFile} theme={theme} />

            <MapModalForm width="80%" show={mapModalShow} onClose={onMapClose} theme={theme} />
            {/* TODO: Ota kaikille käyttöön kun valmis}
            <ImageModalForm width="80%" show={imageModalShow} onClose={onImageClose} theme={theme} />
            */}
          </div>

        </div>


        <hr style={{ width: '100%', height: 0, color: '#000000', borderColor: '#000000', backgroundcolor: '#ce7e00', marginTop: '5px' }} />

        {/*<iframe src=`http://51.15.114.61:3000/d-solo/e8836cce-36b7-407c-ab6c-2f84817a8389/level?orgId=1&refresh=1m&from=now-60m&to=now&panelId=1` width="49%" height="200" frameborder="0"></iframe>*/}

        <iframe src={panel1} width="49%" height="400" frameBorder="0" onClick={iframeTest}></iframe>
        <iframe src={panel2} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel3} width="49%" height="400" frameBorder="0"></iframe>
        <iframe src={panel4} width="49%" height="400" frameBorder="0"></iframe>
      </>
    );

  }  
  // *****keskio

  return (
    <div className={`App ${theme}`}>

      {/*
  <header className="App-header">
    <img src={logo} className="App-logo" alt="logo" /> 
  </header>
  */}



        {!user && loginForm()}
        {user && mainForm()}

    </div>

  )
}




//fftResults();

export default App;
